import { Outlet } from 'react-router-dom';
import AccessDenied from 'pages/maintenance/403';
import usePermissions from 'hooks/usePermissions';

// ==============================|| MAIN LAYOUT ||============================== //

const Content = () => {
  const { permitted } = usePermissions();

  return permitted ? <Outlet /> : <AccessDenied sx={{ minHeight: '75vh' }} />;
};

export default Content;
